import React, { useContext, useRef, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';

const getFieldDropDowns = (data) => async () => {
	const instance = await getAxiosTokenInstance();
	const resp = await instance.get('/college/action/getFieldDropDowns', { params: { ...data } });
	if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
	return resp?.data?.list || [];
};

const SearchableImput = ({ keyData, collection, stateData, setStateData, titleData }) => {
	const { collegeId } = useContext(FirebaseContext);
	const [showList, setShowList] = useState(false);
	const wrapperRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
				setShowList(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const { data: dropdownOptions = [] } = useQuery([keyData, stateData[keyData], collection], getFieldDropDowns({ collegeId, search: stateData[keyData], collection, key: keyData }), { keepPreviousData: true });
	
	const filteredOptions = dropdownOptions?.filter((item) => typeof item === 'string' && item?.toLowerCase().includes((stateData?.[keyData]? stateData?.[keyData] : '')?.toLowerCase())).slice(0, 5);

	return (
		<div className='relative w-full' ref={wrapperRef}>
			<label className='text-sm font-semibold text-gray-800 dark:text-slate-100 mb-1 block'>{titleData}</label>
			<input type='text' className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-[#202020f5] dark:text-white' onKeyPress={(e) => e.which === 13 && e.preventDefault()} onChange={(e) => setStateData({ ...stateData, [keyData]: e.target.value })} onFocus={() => setShowList(true)} value={stateData[keyData]} />

			{showList && filteredOptions?.length > 0 && (
				<div className='absolute z-10 mt-1 w-full bg-slate-600 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-md shadow-md max-h-48 overflow-y-auto'>
					{filteredOptions.map((item, index) => (
						<div key={index} className='px-4 py-2 cursor-pointer bg-slate-100 hover:bg-slate-200 dark:bg-slate-600 dark:hover:bg-slate-700 text-sm text-gray-700 dark:text-gray-200' onClick={() => setStateData({ ...stateData, [keyData]: item })}>
							{item}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default SearchableImput;
